import { find, isArray } from 'lodash';
import {
  Quote,
  QuoteLite,
  QuotePermission,
  QuotePermissionKey,
} from '@lockton-apps/shared/interfaces';
import { isExperimental } from './experimental.helpers';

export function hasPermission(
  quote: Quote | QuoteLite | undefined,
  key: QuotePermissionKey
): boolean {
  if (!quote) {
    return isExperimental();
  }

  if (!quote.permissions || !isArray(quote.permissions)) {
    return false;
  }

  return !!find<QuotePermission | undefined>(quote.permissions, {
    key,
  })?.value;
}
